export default __webpack_public_path__ + "static/media/placeholder_dummy2016-wellness01-mobile-de.33456d65.png";